import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-2e77b452"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "content"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, "Receipts", -1);
});

var _hoisted_3 = ["innerHTML"];
var _hoisted_4 = {
  class: "high-text"
};
import { apiReceiptList } from '@/api/information';
import { ref } from 'vue';
import { headers } from './data';
import RiscernTable from '@/components/RiscernTable/index.vue';
import DefaultDialog from '@/components/DefaultDialog';
import { formatTime } from '@/utils/time';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var keywords = ref('');
    var subBtnLoading = ref(false);
    var tableData = ref({});
    var tableRef = ref(null);
    var receiptsDialogVisible = ref(false);
    var receiptsDialogData = ref({});

    function getData(params) {
      var _tableRef$value;

      return (_tableRef$value = tableRef.value) === null || _tableRef$value === void 0 ? void 0 : _tableRef$value.getData(params);
    }

    function handleView(row) {
      receiptsDialogVisible.value = true;
      receiptsDialogData.value = row || {};
    }

    return function (_ctx, _cache) {
      var _component_el_table_column = _resolveComponent("el-table-column");

      var _component_el_descriptions_item = _resolveComponent("el-descriptions-item");

      var _component_el_descriptions = _resolveComponent("el-descriptions");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", null, [_createVNode(RiscernTable, {
        api: _unref(apiReceiptList),
        ref_key: "tableRef",
        ref: tableRef
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(headers), function (tabItem) {
            return _openBlock(), _createBlock(_component_el_table_column, {
              key: tabItem.key,
              prop: tabItem.key,
              label: tabItem.title
            }, _createSlots({
              _: 2
            }, [tabItem.htmlDomFunc ? {
              name: "default",
              fn: _withCtx(function (scope) {
                return [_createElementVNode("div", {
                  innerHTML: tabItem.htmlDomFunc(scope.row)
                }, null, 8, _hoisted_3)];
              })
            } : tabItem.title === 'Action' ? {
              name: "default",
              fn: _withCtx(function (scope) {
                return [_createElementVNode("div", {
                  class: "high-text--underline",
                  onClick: function onClick($event) {
                    return handleView(scope.row);
                  }
                }, "View", 8, ["onClick"])];
              })
            } : undefined]), 1032, ["prop", "label"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["api"])]), _createVNode(_unref(DefaultDialog), {
        modelValue: receiptsDialogVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return receiptsDialogVisible.value = $event;
        }),
        width: "40%",
        "custom-class": "default-dialog no-footer-dialog login-user"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_descriptions, {
            border: "",
            column: 1
          }, {
            title: _withCtx(function () {
              return [_createElementVNode("span", _hoisted_4, _toDisplayString("Receipt ".concat(receiptsDialogData.value.receiptNo)), 1)];
            }),
            default: _withCtx(function () {
              return [_createVNode(_component_el_descriptions_item, {
                label: "Date"
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(_unref(formatTime)(receiptsDialogData.value.createTime)), 1)];
                }),
                _: 1
              }), _createVNode(_component_el_descriptions_item, {
                label: "Number"
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(receiptsDialogData.value.receiptNo), 1)];
                }),
                _: 1
              }), _createVNode(_component_el_descriptions_item, {
                label: "Payment method"
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(receiptsDialogData.value.cardNo), 1)];
                }),
                _: 1
              }), _createVNode(_component_el_descriptions_item, {
                label: "Retailer"
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(receiptsDialogData.value.retailer), 1)];
                }),
                _: 1
              }), _createVNode(_component_el_descriptions_item, {
                label: "Address"
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(receiptsDialogData.value.address), 1)];
                }),
                _: 1
              }), _createVNode(_component_el_descriptions_item, {
                label: "Product"
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(receiptsDialogData.value.product), 1)];
                }),
                _: 1
              }), _createVNode(_component_el_descriptions_item, {
                label: "Total"
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(receiptsDialogData.value.amount) + " USD", 1)];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
});